import { useIntl } from 'react-intl';

import calmAppQrCode from '@/../public/_n/images/b2b/Calm_App_QR_Code.png';
import Image from '@/components/image/NextImage';
import { StoreButton } from '@/components/ui/StoreButton';

import messages from './messages';
import {
	ButtonColumn,
	Container,
	Header,
	QrCodeAndStoreButtonContainer,
	QrCodeContainer,
	StoreButtonContainer,
} from './styles';

const SuccessQrCode: React.FC = () => {
	const { formatMessage } = useIntl();

	return (
		<Container>
			<Header>{formatMessage(messages.scanQrInstructions)}</Header>
			<QrCodeAndStoreButtonContainer>
				<QrCodeContainer>
					<Image src={calmAppQrCode} height={148} width={148} alt="a QR code to download the Calm app" />
				</QrCodeContainer>
				<StoreButtonContainer>
					<StoreButton isSmall isDynamicWidth type="ios" />
					<ButtonColumn>
						<StoreButton isSmall isDynamicWidth type="android" />
					</ButtonColumn>
				</StoreButtonContainer>
			</QrCodeAndStoreButtonContainer>
		</Container>
	);
};

export default SuccessQrCode;
